import { Link } from "react-router-dom";

import { Table } from "../../../../../../components/Functional";
import { FETCH_CONSIGNMENTS as fetchConsignments } from "../../../../../../graphql/query/Consignment";
import SectionHeader from "../../components/SectionHeader";

const FETCH_CONTACT_CONSIGNMENTS = fetchConsignments({
  contact: { company: true, name: true },
  consigner: { company: true, name: true },
  channel: { description: true },
  company: { name: true },
  status: { description: true },
  type: { description: true },
  due: true,
  date: true,
});

const ContactCell = props => {
  const { contactKey, values } = props;
  const contact = values?.[contactKey];
  const label = contact?.company || contact?.name;

  return contact?.id ? (
    <Link className="underline" to={`/contacts/${contact.id}/details`}>
      {label}
    </Link>
  ) : (
    label
  );
};

const headers = [
  {
    label: "Id",
    name: "id",
    type: "custom",
    component: props => (
      <Link
        className="underline"
        to={`/consignment/${props?.values?.id}/form`}
      >
        {props?.values?.id}
      </Link>
    ),
  },
  {
    label: "Consigner",
    name: "consigner",
    type: "custom",
    component: props => <ContactCell {...props} contactKey="consigner" />,
  },
  {
    label: "Consignee",
    name: "contact",
    type: "custom",
    component: props => <ContactCell {...props} contactKey="contact" />,
  },
  { label: "Channel", name: "channel.description", type: "label" },
  { label: "Company", name: "company.name", type: "label" },
  { label: "Status", name: "status.description", type: "label" },
  { label: "Type", name: "type.description", type: "label" },
  { label: "Due Date", name: "due", type: "date" },
  { label: "Date", name: "date", type: "date" },
];

const ConsignmentList = props => {
  const { contactId, emptyMessage, filterName, title } = props;

  return (
    <section className="w-full">
      <h2 className="text-xl font-bold">{title}</h2>
      <Table
        dataKey="consignments"
        emptyMessage={emptyMessage}
        FETCH_QUERY={FETCH_CONTACT_CONSIGNMENTS}
        headers={headers}
        isSubTable
        variables={{ [filterName]: contactId }}
        variant="dynamicHeight"
      />
    </section>
  );
};

const ContactConsignments = props => {
  const { contactId } = props || {};
  const lists = [
    {
      title: "Consigned To",
      emptyMessage: "No consignments consigned to this contact",
      filterName: "contactId",
    },
    {
      title: "Consigned By",
      emptyMessage: "No consignments consigned by this contact",
      filterName: "consignerId",
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Consignments" />
      <div className="flex w-full flex-col gap-10">
        {lists.map(list => (
          <ConsignmentList
            key={list.filterName}
            contactId={contactId}
            {...list}
          />
        ))}
      </div>
    </div>
  );
};

export default ContactConsignments;
